type StartupTelemetryDetails = {
  message?: string;
  stack?: string;
  source?: string;
};

type StartupTelemetryApi = {
  markStarted: () => void;
  report: (type: string, details?: StartupTelemetryDetails) => void;
};

declare global {
  interface Window {
    __IFOOD_STARTUP_TELEMETRY__?: StartupTelemetryApi;
  }
}

const getErrorDetails = (error: unknown, source?: string): StartupTelemetryDetails => {
  if (error instanceof Error) {
    return {
      message: error.message,
      stack: error.stack,
      source,
    };
  }

  return {
    message: typeof error === 'string' ? error : String(error),
    source,
  };
};

/**
 * markAppStartupComplete
 *
 * Signals the inline startup monitor after the React tree commits. It receives
 * no data, depends on the bootstrap API installed by public/index.html, and
 * clears the preview-page timeout without exposing user or order information.
 */
export function markAppStartupComplete(): void {
  window.__IFOOD_STARTUP_TELEMETRY__?.markStarted();
}

/**
 * reportAppStartupError
 *
 * Reports an early React failure through the same-origin startup monitor. It
 * receives a stable error type plus an unknown thrown value and optional source
 * context; the inline monitor enriches and sends only startup diagnostics.
 */
export function reportAppStartupError(type: string, error: unknown, source?: string): void {
  window.__IFOOD_STARTUP_TELEMETRY__?.report(type, getErrorDetails(error, source));
}

export {};
